<script lang="ts">
    import {fade} from 'svelte/transition';

    import Cross from 'general/icons/Cross.svelte';
    import {FLAGS} from 'general/constants';
    import {modal, dyData} from 'general/store';
    import {ANIMATION_DURATION} from 'general/constants';

    import s from './style.module.css';

    export let handleClick: () => void;
    export let theme = 'dark';
    export let delay = 3000;
    export let crossColor = '#2A2727';
    export let side: 'main' | 'subscribed' | 'typ' | 'sms' | 'prize' = 'main';
    export let size = 14;
    export let noHeader = false;
    export let strokeWidth = 1.2;
</script>

<button
    in:fade|global={{
        duration: $modal.isFirstExperience ? ANIMATION_DURATION.CLOSE_BUTTON : 0,
        delay: $modal.isFirstExperience && $dyData.flag !== FLAGS.CROSS_WITHOUT_DELAY ? delay : 0,
    }}
    out:fade={{duration: 0}}
    class="{s.cross} {s[theme] || ''} {s[side] || ''}"
    class:s.noHeader={noHeader}
    class:s.closeButtonColor={$dyData.isSmallerScreen}
    class:s.popupWithPrice={$dyData?.isLoadImage?.titleWithPrice}
    type="button"
    on:introend={modal.setFirstExperience}
    on:click={handleClick}
    aria-label="Close popup"
>
    <Cross color={crossColor} width={size} height={size} {strokeWidth} />
</button>
